var homeSlider = {
    init: function () {
        var homeSliderEl = document.getElementById('home-slider');

        if (homeSliderEl === null) return;

        var slides = homeSliderEl.querySelectorAll('.slide'),
            swipeIconEl = document.getElementById('swipe-icon'),
            restOfHomePageEl = document.getElementById('rest-of-home-page'),
            slidesWrapperEl = document.getElementById('slides-wrapper'),
            bgWrapperEl = document.getElementById('bg-wrapper'),
            scrollTop = 0,
            lastSt = 0,
            slideActiveClass = 'is-active',
            slideShownClass = 'is-shown',
            scrollDisabledClass = 'scroll-disabled',
            perspectiveSliderClass = 'perspective-slider-enabled',
            wheelDirection = 0,
            dirUp = 'up',
            dirDown = 'down';

        /**
         * Zwraca wysokość slajdu
         * @returns {number}
         */
        var slideHeight = function () {
            return slides[0].offsetHeight;
        };

        /**
         * Zwraca pozycje dla slajdów na podstawie których podczas scrollowania dobierany jest aktywny slajd
         * @returns {Array}
         */
        var slidesPositions = function () {
            var positions = [],
                sh = slideHeight(),
                threshold = 0.1; // 0-1

            for (var i = 0; i < slides.length; i++) {
                var start = i * sh;
                positions[i] = {
                    start: start,
                    middle: start + Math.round(sh / 2),
                    end: i === slides.length - 2 ? start + sh + 3 : start + sh, // Dla przedostatniego slajdu dokładam 3px, dzięki którym slajder przy ostatnim slajdzie nie będzie blokował scrolla
                    prev: start - Math.round(sh * threshold),
                    next: start + sh + Math.round(sh * threshold)
                }
            }

            return positions;
        };

        /**
         * Animacja po kliknięciu w przycisk Przewiń
         */
        swipeIconEl.addEventListener('click', function () {
            anime.remove("html,body");

            anime({
                targets: "html,body",
                scrollTop: restOfHomePageEl.offsetTop - headerMenu.mobileHeaderHeight + 20,
                duration: 750,
                easing: 'easeOutCubic'
            });
        });

        var scrollingTimeout;
        var isScrolling = false;
        var isAnimating = false;
        var positions = slidesPositions();

        /**
         * Obsługa scrolla na sliderze mobilnym
         */
        var perspectiveSliderScrollHandler = function () {
            var st = homeSliderEl.scrollTop,
                sh = slideHeight(),
                dir;

            if (st === lastSt) {
                return;
            }

            isScrolling = true;

            if (st > lastSt) {
                dir = dirDown;
            } else {
                dir = dirUp
            }

            for (var i = 0; i < positions.length; i++) {
                if (dir === dirUp) {
                    if (st > positions[i].prev) scrollTop = positions[i].start;
                } else {
                    if (st + sh >= positions[i].next) {
                        scrollTop = positions[i].end;
                    }
                }

                var op = 1 - Math.abs((st) / (positions[i].end - positions[i].start) - i) * 1.5;
                slides[i].style.opacity = Math.max(0, Math.min(op, 1));
            }

            //console.log(st, scrollTop);

            window.clearTimeout(scrollingTimeout);
            scrollingTimeout = setTimeout(function () {
                isScrolling = false;

                if (!isTouching && !isAnimating) {
                    animatePerspectiveSlider(scrollTop);
                }
            }, 200);

            lastSt = st;
        };

        var scrollObject = {scroll: homeSliderEl.scrollTop};

        /**
         * Animacja przewijana do danego slajdu
         * @param st
         */
        //todo-kt na ipadzie jest problem zeby przescrolowac dalej - scroll dziala tylko w ramach slidera
        var animatePerspectiveSlider = function (st) {
            isAnimating = true;
            addClass(homeSliderEl, scrollDisabledClass);
            anime.remove(scrollObject);
            scrollObject.scroll = homeSliderEl.scrollTop;

            if (window.pageYOffset > slideHeight() * slides.length) return;

            anime({
                targets: scrollObject,
                scroll: st,
                easing: 'easeOutCubic',
                duration: 500,
                run: function (a) {
                    homeSliderEl.scrollTop = a.animations[0].currentValue;
                },
                complete: function () {
                    removeClass(homeSliderEl, scrollDisabledClass);
                    setTimeout(function () {
                        isAnimating = false;
                    }, 300);

                    var index = 0;
                    for (var i = 0; i < positions.length; i++) {
                        if (st > positions[i].prev) {
                            index = i;
                        }
                    }

                    removeClass(homeSliderEl.querySelector('.slide.' + slideActiveClass), slideActiveClass);
                    addClass(slides[index], slideActiveClass);
                }
            });
        };


        /**
         * Poprawka pozycji w związku z widocznym paskiem adresu na telefonie
         */
        var addressBarCorrection = function () {
            var diff = (window.innerHeight - homeSliderEl.offsetHeight) / 2;

            if (hasClass(homeSliderEl, perspectiveSliderClass)) {
                slidesWrapperEl.style.transform = 'translateY(' + diff + 'px)';
            }
        };

        window.addEventListener('resize', addressBarCorrection);
        window.addEventListener('load', addressBarCorrection);

        var isTouching = false;

        /**
         * Obsługa dotyku - touchStart
         */
        var touchStartHandler = function () {
            isTouching = true;
            anime.remove(scrollObject);
            if (window.pageYOffset === 0) {
                removeClass(homeSliderEl, scrollDisabledClass);
            }
        };

        /**
         * Obsługa dotyku - touchEnd
         */
        var touchEndHandler = function () {
            isTouching = false;

            if (!hasClass(homeSliderEl, scrollDisabledClass)) {
                animatePerspectiveSlider(scrollTop);
            }
        };

        /**
         * Obsługa scrolla całej strony przy aktywnym perspective sliderze
         */
        var perspectiveSliderWindowScrollHandler = function () {
            if (window.pageYOffset === 0) {
                removeClass(homeSliderEl, scrollDisabledClass)
            } else {
                addClass(homeSliderEl, scrollDisabledClass)
            }
        };

        var noPerspectiveSliderWindowScrollHandler = function () {
            var st = window.pageYOffset;

            for (var i = 0; i < positions.length; i++) {
                var op = 1 - Math.abs((st) / (positions[i].end - positions[i].start) - i) * 1.5;
                slides[i].style.opacity = Math.max(0, Math.min(op, 1));
            }
        };

        var perspectiveSliderLoadHandler = function () {
            addClass(slides[0], slideActiveClass);
            addClass(slidesWrapperEl, 'loaded');
        };

        var rafPerspectiveSliderScrollHandler = rafThrottle(perspectiveSliderScrollHandler);
        var rafPerspectiveSliderWindowScrollHandler = rafThrottle(perspectiveSliderWindowScrollHandler);
        var rafNoPerspectiveSliderWindowScrollHandler = rafThrottle(noPerspectiveSliderWindowScrollHandler);

        /**
         * Włącza/wyłącza perspective slider w zależności od spełnionych warunków
         */
        var setupPerspectiveSlider = function () {
            if (!breakpoints.match(breakpoints.lg)) {
                if (isTouchDevice()) {//todo-kt można tu sprawdzić czy dane urządzenie obsługuje właściwie CSS perspective
                    addClass(homeSliderEl, perspectiveSliderClass);
                    homeSliderEl.addEventListener('scroll', rafPerspectiveSliderScrollHandler);
                    homeSliderEl.addEventListener('touchstart', touchStartHandler);
                    homeSliderEl.addEventListener('touchend', touchEndHandler);
                    window.addEventListener('scroll', rafPerspectiveSliderWindowScrollHandler);

                    window.removeEventListener('scroll', rafNoPerspectiveSliderWindowScrollHandler);
                    window.addEventListener('load', perspectiveSliderLoadHandler);

                    if(isFirefox()){
                        addClass(homeSliderEl, 'no-perspective');
                    }
                } else {
                    window.addEventListener('scroll', rafNoPerspectiveSliderWindowScrollHandler);
                    window.addEventListener('load', perspectiveSliderLoadHandler);
                }
            } else {
                removeClass(homeSliderEl, perspectiveSliderClass);
                homeSliderEl.removeEventListener('scroll', rafPerspectiveSliderScrollHandler);
                homeSliderEl.removeEventListener('touchstart', touchStartHandler);
                homeSliderEl.removeEventListener('touchend', touchEndHandler);

                window.removeEventListener('scroll', rafPerspectiveSliderWindowScrollHandler);
                window.removeEventListener('scroll', rafNoPerspectiveSliderWindowScrollHandler);
                window.removeEventListener('load', perspectiveSliderLoadHandler);
                slides.forEach(function (item) {
                    item.removeAttribute('style');
                })
            }
        };

        var depthEls = [],
            speedFactor = 20;
        
        var calculateBgPositions = function (st) {

            if(depthEls.length === 0) {
                var els = bgWrapperEl.querySelectorAll('g');
                for(var i = 0; i < els.length; i++){
                    depthEls[i] = {
                        el: els[i],
                        speed: els[i].getAttribute('class').match(/depth(\d)/)[1]
                    };
                }
            }

            depthEls.forEach(function (item) {
                item.el.style.transform = 'translate3d(0,' + st / (-speedFactor * item.speed) + 'px, 0)';
            });
        };


        window.addEventListener('load', function () {
                calculateBgPositions(window.pageYOffset);
        });




        var isDesktopAnimating = false;
        var animateDesktopSlider = function (st) {
            isDesktopAnimating = true;
            anime.remove("html,body");

            anime({
                targets: "html,body",
                scrollTop: st,
                duration: 750,
                easing: 'easeOutCubic',
                complete: function () {
                    setTimeout(function () {
                        isDesktopAnimating = false;
                    }, 0);
                }
            });
        };

        /**
         * obsługuje pokrętło myszki i przewija slider do kolejnych/poprzednich elementów
         */
        var desktopSliderMouseWheelHandler = function () {
            var st = window.pageYOffset,
                sh = slideHeight(),
                dir = wheelDirection;

            var scrollTop = 0;

            for (var i = 0; i < positions.length; i++) {
                if (dir === -1) { // scroll down
                    if (st > positions[i].prev) scrollTop = i === positions.length - 1 ? restOfHomePageEl.offsetTop - headerMenu.mobileHeaderHeight + 20 : positions[i].end;
                } else {
                    if (st + sh >= positions[i].next) {
                        scrollTop = positions[i].start;
                    }
                }
            }

            animateDesktopSlider(scrollTop);
        };

        /*var throttledDesktopSliderMouseWheelHandler = function (e) {
            e.preventDefault();
            throttle(desktopSliderMouseWheelHandler(e), 1000);
        };*/

        var throttledDesktopSliderMouseWheelHandler = throttle(desktopSliderMouseWheelHandler, 500);

        /**
         * Obsługa scrolla na sliderze desktopowym
         */
        var desktopSliderScrollHandler = function (forceUpdate) {
            var st = window.pageYOffset,
                sh = slideHeight();

            forceUpdate = (typeof forceUpdate === 'undefined') ? false : forceUpdate;
            
            if (forceUpdate !== 'yes' && (st === lastSt || lastSt === 0)) {
                lastSt = st;
                return;
            }

            isScrolling = true;

            calculateBgPositions(st);

            var index = 0;
            for (var i = 0; i < positions.length; i++) {
                if (st > positions[i].middle - sh) {
                    index = i;
                }

                if (st > positions[i].middle) {
                    if(i < slides.length - 1){
                        addClass(slides[i], slideShownClass);
                    }
                } else {
                    removeClass(slides[i], slideShownClass);
                }
            }

            if (!hasClass(slides[index], slideActiveClass)){
                removeClass(homeSliderEl.querySelector('.slide.' + slideActiveClass), slideActiveClass);
                addClass(slides[index], slideActiveClass);
            }


            if(st > positions[slides.length - 1].start) {

                if(st < restOfHomePageEl.offsetTop){
                    var diff = st - positions[slides.length - 1].start;
                    slidesWrapperEl.style.transform = 'translateY(' + diff / -3 + 'px)';
                    slidesWrapperEl.style.opacity = 1 - (st - positions[slides.length - 1].start) / (restOfHomePageEl.offsetTop - positions[slides.length - 1].start);
                }

            } else {
                slidesWrapperEl.style.transform = 'translateY(' + 0 + 'px)';
                slidesWrapperEl.style.opacity = 1;
            }

            if(forceUpdate == 'yes') {
                setTimeout(function () {
                    addClass(slidesWrapperEl, 'loaded');
                }, 500);

                setTimeout(function () {
                    addClass(bgWrapperEl, 'no-transition');
                }, 1000);

            }

            lastSt = st;
        };

        var rafDesktopSliderScrollHandler = rafThrottle(desktopSliderScrollHandler);

        var originalTextsOnSlides = [];
        var isTextsPrepared = false;

        /**
         * Przygotowuje teksty na slajdach do wyświetlania na desktopowym slajderze
         */
        var prepareTextsOnSlides = function () {
            if(isTextsPrepared) return;

            originalTextsOnSlides = [];
            slides.forEach(function (item) {
                var el = item.querySelector('.text'),
                    text = el.innerHTML,
                    formatedText = '';

                originalTextsOnSlides.push(text);

                text.split('<br>').forEach(function (t) {
                    formatedText += '<span><em>' + t + '</em></span>';
                });

                el.innerHTML = formatedText;
            });

            isTextsPrepared = true;
        };

        var revertTextsOnSlides = function () {
            if(!isTextsPrepared) return;

            var length = originalTextsOnSlides.length;

            for(var i = 0; i < length; i++) {
                var el = slides[i].querySelector('.text');
                el.innerHTML = originalTextsOnSlides[i];
            }

            isTextsPrepared = false;
        };

        var lockWheel = function (e) {
            if(isDesktopAnimating){
                e.preventDefault();
            }
        };

        var wheelEnabled = false;
        // Hamster - biblioteka normalizująca obsługę kółka myszy międzi przeglądarkami
        var hamster = Hamster(homeSliderEl);

        var firstLoad = true;

        var desktopSliderLoadHandler = function () {
            prepareTextsOnSlides();
            firstLoad = false;

            setTimeout(function () {
                desktopSliderScrollHandler('yes');
            }, 100);

        };



        /**
         * Włącza/wyłącza desktop slider w zależności od spełnionych warunków
         */
        var setupDesktopSlider = function () {
            if (breakpoints.match(breakpoints.lg)) {
                window.addEventListener('scroll', rafDesktopSliderScrollHandler);
                if(!wheelEnabled) {
                    hamster.wheel(function(event, delta, deltaX, deltaY){
                        wheelDirection = deltaY > 0 ? 1 : -1;
                        var dist = Math.abs(deltaY);
                        if(dist >= 1 && dist === parseInt(dist, 10)){
                            event.preventDefault();
                            if(!isDesktopAnimating){
                                throttledDesktopSliderMouseWheelHandler();
                            }
                        }
                    });
                    wheelEnabled = true;
                }
                if(!firstLoad) {
                    prepareTextsOnSlides();
                }

                window.addEventListener('wheel', lockWheel);
                window.addEventListener('load', desktopSliderLoadHandler);
            } else {
                window.removeEventListener('scroll', rafDesktopSliderScrollHandler);
                //homeSliderEl.removeEventListener('wheel', desktopWheelHandler);
                if(wheelEnabled){
                    hamster.unwheel();
                    wheelEnabled = false;
                }
                revertTextsOnSlides();
                window.removeEventListener('wheel', lockWheel);
                window.removeEventListener('load', desktopSliderLoadHandler);
                firstLoad = false;

            }
        };

        var setupSliders = function () {
            positions = slidesPositions();
            //todo-kt aktualizacja pozycji po resize
            setupPerspectiveSlider();
            //setup desktop slider
            setupDesktopSlider();

            //console.log('resize');
        };

        window.addEventListener('resize', setupSliders);
        setupSliders();
    }
};